import { Stack, Typography } from '@mui/material';
import { ScatterChart } from '@mui/x-charts/ScatterChart';

interface ScatterPoint {
    id: number;
    x: number;
    y: number;
}

interface ScatterChartComponentProps {
    data: ScatterPoint[];
    height?: number;
    title: string;
}

function ScatterChartComponent({ data, height = 280, title }: Readonly<ScatterChartComponentProps>) {
    return (
        <Stack
            sx={{
                flex: 1,
            }}
        >
            <Typography sx={{ mb: 1 }} variant="subtitle2">
                {title}
            </Typography>
            <ScatterChart
                height={height}
                series={[
                    {
                        data,
                        label: 'Data correlation',
                    },
                ]}
                xAxis={[
                    {
                        label: 'Dataset 1',
                        max: 100,
                        min: 0,
                    },
                ]}
                yAxis={[
                    {
                        label: 'Dataset 2',
                        max: 100,
                        min: 0,
                    },
                ]}
            />
        </Stack>
    );
}

export default ScatterChartComponent;
